import {Endpoint} from '@eryxcoop/appyx-comm';

export default class GetPaymentReminderPreviewEndpoint extends Endpoint {

    adaptValues({taxpayerIdentificationNumber}) {
        return {
            taxpayer_identification_number: taxpayerIdentificationNumber,
        }
    }
}
